import { Container, IInit } from '../../../common/container/Container'
import { UserContainerConfig } from '../container'
import { Observable, of } from 'rxjs'
import { HTTP_CLIENT_KEY, IHTTPClient } from '../../../common/api/HTTPClient'
import { IStatusService } from '../../../common/status/StatusService'
import { catchError, map } from 'rxjs/operators'
import { STATUS_SERVICE_KEY } from '../../../container/app'

export interface PendingRegistrationResponse {
  id: string
  firstName: string
  lastName: string
  email: string
}

export interface CompleteRegistrationRequest {
  token: string
  email: string
  password: string
}

export interface IPendingRegistrationApi extends IInit {
  getByToken(token: string): Observable<PendingRegistrationResponse | undefined>
  completeRegistration(request: CompleteRegistrationRequest): Observable<boolean>
}

export class PendingRegistrationApi implements IPendingRegistrationApi {
  private _container!: Container
  private _httpClient!: IHTTPClient
  private _url!: string
  private _statusService!: IStatusService

  init(c: Container) {
    this._container = c
    this._httpClient = this._container.get<IHTTPClient>(HTTP_CLIENT_KEY)
    this._statusService = this._container.get<IStatusService>(STATUS_SERVICE_KEY)
    this._url = (this._container.config as UserContainerConfig).moduleFullUrl
  }

  getByToken(token: string): Observable<PendingRegistrationResponse | undefined> {
    return this._httpClient
      .get<PendingRegistrationResponse>({
        url: `${this._url}/registration/${token}`,
      })
      .pipe(
        catchError((err) => {
          this._statusService.sendStatus({ variant: 'error', error: err })
          return of(undefined)
        })
      )
  }

  completeRegistration(request: CompleteRegistrationRequest): Observable<boolean> {
    return this._httpClient
      .post<any>({
        url: `${this._url}/complete-registration`,
        body: request,
      })
      .pipe(
        map(() => true),
        catchError((err) => {
          this._statusService.sendStatus({ variant: 'error', error: err })
          return of(false)
        })
      )
  }
}
